var generic = generic || {};
var site = site || {};

(function ($) {
  Drupal.behaviors.emailSignupFormCustomInputV1 = {
    attach: function (context) {}
  };
})(jQuery);
